import React from 'react'
import PropTypes from 'prop-types'

import './InfoPanel.scss'

const InfoPanel = ({
    icon,
    title,
    description,
    onClick = () => {},
    link,
    gtmCategory,
    gtmAction,
    gtmLabel
}) => (
    <a
        target="_blank"
        rel="noopener noreferrer"
        className="info-panel"
        onClick={onClick}
        href={link}
        data-gtm-event-category={gtmCategory}
        data-gtm-event-action={gtmAction}
        data-gtm-event-label={gtmLabel}
    >
        <img src={icon} alt="Icone" />
        <h2 className="info-panel__title">{title}</h2>
        <p className="info-panel__description">{description}</p>
    </a>
)

InfoPanel.propTypes = {
    icon: PropTypes.any.isRequired,
    link: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
}

export default InfoPanel
